import { render, staticRenderFns } from "./sendproductinfo.vue?vue&type=template&id=7cfbaef6&scoped=true&"
import script from "./sendproductinfo.vue?vue&type=script&lang=js&"
export * from "./sendproductinfo.vue?vue&type=script&lang=js&"
import style0 from "./sendproductinfo.vue?vue&type=style&index=0&id=7cfbaef6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfbaef6",
  null
  
)

export default component.exports